export namespace FiMstAttributeConstants {
    export enum AttributeSetType {
        PRODUCT_SELECTOR = 'PRODUCT_SELECTOR',
        PRODUCT_SPECS = 'PRODUCT_SPECS'
    }
}